const schema = (props) => {
  const { intl } = props;

  return {
    title: 'Hero Block',
    fieldsets: [
      {
        id: 'default',
        title: 'Default',
        fields: [
          'kicker',
          'title',
          'subtitle',
          'backgroundImage',
          'backgroundVideo',
          'usePageTitle',
          'usePageDescription',
          'usePreviewImage',
          'showPublicationDate',
          'showBreadcrumbs',
          'isFullWidth',
          'alignment',
          'smallButtons',
          'useTOC',
          'useH2',
          'useH3',
          'useBlockTitles',
          'buttons',
          'videoOnSide',
        ],
      },
      {
        id: 'video_options',
        title: 'Video Options',
        fields: [
          'videoPoster',
          'videoMobileOrder',
          'videoCTA',
        ],
      },
    ],
    properties: {
      kicker: {
        title: 'Kicker text (small text above title)',
        type: 'string',
        description: 'Optional small text that appears above the main title',
      },
      usePageTitle: {
        title: 'Use page title as block title',
        type: 'boolean',
        default: false,
      },
      usePageDescription: {
        title: 'Use page description as block subtitle',
        type: 'boolean',
        default: false,
      },
      title: {
        title: 'Title',
        widget: 'textarea',
        description: 'Supports line breaks and basic HTML like <strong>bold</strong>',
      },
      subtitle: {
        title: 'Subtitle',
        widget: 'textarea',
        description: 'Supports line breaks and basic HTML like <strong>bold</strong>',
      },
      backgroundImage: {
        title: 'Background image',
        widget: 'object_browser',
        mode: 'image',
        allowExternals: false,
      },
      backgroundVideo: {
        title: 'Background video',
        widget: 'object_browser',
        mode: 'file',
        allowExternals: false,
        selectableTypes: ['File'],
        description: 'MP4 only. Will autoplay, loop, and stay muted.',
      },
      usePreviewImage: {
        title: 'Use page Preview image',
        type: 'boolean',
        default: false,
      },
      alignment: {
        title: 'Text alignment',
        widget: 'align',
        actions: ['left', 'center', 'right'],
        default: 'left',
      },
      isFullWidth: {
        title: 'Full width background',
        type: 'boolean',
        default: false,
      },
      showPublicationDate: {
        title: 'Show publication date',
        type: 'boolean',
        default: false,
      },
      showBreadcrumbs: {
        title: 'Show breadcrumbs',
        type: 'boolean',
        default: false,
        description: 'Displays the page breadcrumb trail above the title. Hides the site breadcrumbs below the hero.',
      },
      useH2: {
        title: 'Include H2 headings in TOC',
        type: 'boolean',
        default: true,
      },
      useH3: {
        title: 'Include H3 headings in TOC',
        type: 'boolean',
        default: true,
      },
      useTOC: {
        title: 'Use TOC instead of buttons',
        type: 'boolean',
        default: false,
      },
      useBlockTitles: {
        title: 'Include block headings in TOC',
        type: 'boolean',
        default: false,
        description: 'Adds block-level headings (e.g. listing titles, section headers) to the TOC alongside H2/H3 headings.',
      },
      buttons: {
        title: 'Buttons',
        widget: 'object_list',
        schema: {
          title: 'Button',
          fieldsets: [
            {
              id: 'default',
              title: 'Default',
              fields: ['label', 'link'],
            },
          ],
          properties: {
            label: {
              title: 'Label',
              type: 'string',
            },
            link: {
              title: 'Link',
              widget: 'object_browser',
              mode: 'link',
              allowExternals: true,
              multi: false,
              default: null,
            },
          },
          required: [],
        },
      },
      smallButtons: {
        title: 'Use smaller buttons',
        type: 'boolean',
        default: false,
      },
      videoOnSide: {
        title: 'Show video on the side (two-column layout)',
        type: 'boolean',
        default: false,
        description: 'Creates a side-by-side layout with video player. Requires background video.',
      },
      videoPoster: {
        title: 'Video poster image',
        widget: 'object_browser',
        mode: 'image',
        allowExternals: false,
        description: 'Optional custom poster image for the video player. If not set, uses background image.',
      },
      videoMobileOrder: {
        title: 'Video position on mobile',
        type: 'string',
        choices: [
          ['top', 'Top (video first)'],
          ['bottom', 'Bottom (video second)'],
        ],
        default: 'top',
        description: 'Choose whether video appears first or second on mobile devices.',
      },
      videoCTA: {
  	title: 'Video CTA Button',
  	widget: 'object',
  	schema: {
    	  title: 'Video Call-to-Action',
    	  fieldsets: [
      	    {
        	id: 'default',
        	title: 'Default',
        	fields: ['label', 'link'],
      	    },
    	  ],
    	  properties: {
      	   label: {
           title: 'Button Label',
           type: 'string',
      	  },
      	  link: {
            title: 'Button Link',
            widget: 'object_browser',
            mode: 'link',
            allowExternals: true,
            multi: false,
            default: null,
      	   },
    	 },
    required: [],
  },
},
    },
    required: [],
  };
};

export default schema;
